// @ts-nocheck
import * as React from "react";

const PersonAddFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M18.25 13.5v-3h-3v-1h3v-3h1v3h3v1h-3v3h-1ZM9 11.384a2.889 2.889 0 0 1-2.119-.881A2.889 2.889 0 0 1 6 8.384c0-.825.294-1.531.881-2.118A2.889 2.889 0 0 1 9 5.384a2.89 2.89 0 0 1 2.119.882c.587.587.881 1.293.881 2.118s-.294 1.532-.881 2.119A2.89 2.89 0 0 1 9 11.384Zm-7 7.231V16.97c0-.413.12-.8.36-1.159.241-.36.564-.638.97-.837a14.205 14.205 0 0 1 2.833-1.019A12.15 12.15 0 0 1 9 13.615c.946 0 1.892.113 2.836.34.945.226 1.89.565 2.833 1.018.407.199.73.478.97.837.24.36.361.746.361 1.159v1.646H2Zm1-1h12v-.646c0-.222-.072-.43-.214-.625a1.724 1.724 0 0 0-.594-.494 12.692 12.692 0 0 0-2.546-.916 11.186 11.186 0 0 0-5.293 0c-.874.212-1.722.517-2.545.916-.253.134-.45.3-.593.494a1.037 1.037 0 0 0-.215.625v.646Zm6-7.23c.55 0 1.02-.197 1.412-.588.392-.392.588-.863.588-1.413s-.196-1.02-.588-1.412A1.926 1.926 0 0 0 9 6.384c-.55 0-1.02.196-1.412.588A1.926 1.926 0 0 0 7 8.384c0 .55.196 1.021.588 1.413.391.391.862.587 1.412.587Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(PersonAddFill);
